import {
  IconArrowGuide,
  IconBrandVisualStudio,
  IconCloud,
  IconNews,
  IconSpeakerphone,
  IconSquareAsterisk,
  IconTerminal2,
} from '@tabler/icons-react';

export const TAGS_BLOG = [
  {
    label: 'All',
    href: '/blog',
    className:
      'bg-slate-1 border-slate-6 text-slate-10 hover:bg-slate-3 hover:text-slate-11 data-[active=true]:bg-slate-5 data-[active=true]:text-slate-12',
    Icon: IconSquareAsterisk,
  },
  {
    label: 'Announcement',
    href: '/blog/tag/announcement',
    className:
      'bg-green-1 border-green-6 text-green-10 hover:bg-green-3 hover:text-green-11 data-[active=true]:bg-green-5 data-[active=true]:text-green-12',
    Icon: IconSpeakerphone,
  },
  {
    label: 'Company news',
    description: 'What have we been up to at Artillery?',
    href: '/blog/tag/company',
    className:
      'bg-indigo-1 border-indigo-6 text-indigo-10 hover:bg-indigo-3 hover:text-indigo-11 data-[active=true]:bg-indigo-5 data-[active=true]:text-indigo-12',
    Icon: IconNews,
  },
  {
    label: 'How to',
    href: '/blog/tag/howto',
    className:
      'bg-amber-1 border-amber-6 text-amber-10 hover:bg-amber-3 hover:text-amber-11 data-[active=true]:bg-amber-5 data-[active=true]:text-amber-12',
    Icon: IconArrowGuide,
  },
];

export const TAGS_CHANGELOG = [
  {
    label: 'All',
    href: '/changelog',
    className:
      'bg-slate-1 border-slate-6 text-slate-10 hover:bg-slate-3 hover:text-slate-11 data-[active=true]:bg-slate-5 data-[active=true]:text-slate-12',
    Icon: IconSquareAsterisk,
  },
  {
    label: 'CLI',
    href: '/changelog/tag/cli',
    className:
      'bg-green-1 border-green-6 text-green-10 hover:bg-green-3 hover:text-green-11 data-[active=true]:bg-green-5 data-[active=true]:text-green-12',
    Icon: IconTerminal2,
  },
  {
    label: 'Dashboard',
    href: '/changelog/tag/dashboard',
    className:
      'bg-blue-1 border-blue-6 text-blue-10 hover:bg-blue-3 hover:text-blue-11 data-[active=true]:bg-blue-5 data-[active=true]:text-blue-12',
    Icon: IconCloud,
  },
  {
    label: 'VS Code Extension',
    href: '/changelog/tag/vscode-extension',
    className:
      'bg-teal-1 border-teal-6 text-teal-10 hover:bg-teal-3 hover:text-teal-11 data-[active=true]:bg-teal-5 data-[active=true]:text-teal-12',
    Icon: IconBrandVisualStudio,
  },
];
